<template>
  <div id="chat-container" v-if="chatOpen">
    <list
      @navigate-to-conversation="activateConversation"
      @navigate-to-search="activateSearch"
      v-if="view === 'list'"
    />
    <conversation
      v-if="view === 'conversation'"
      :conversation="activeConversation"
      @send-message="sendMessage"
      @back="back"
    />
    <contact-search
      v-if="view === 'contact-search'"
      @select-contact="selectContact"
    />
  </div>
  <navigation-icon id="spin-chat-icon" icon="chat" @click="toggleChat" />
</template>
<script>
import NavigationIcon from "../Navigation/NavigationIcon.vue";
import List from "./Components/List.vue";
import Conversation from "./Components/Conversation.vue";
import ContactSearch from "./Components/ContactSearch.vue";
export default {
  data() {
    return {
      chatOpen: false,
      view: "contact-search",
      currentView: undefined,
      messageActive: false,
      activeConversation: undefined,
      conversationLoading: true,
    };
  },
  computed: {
    userRole() {
      return this.$store.getters.user.role;
    },
  },
  // todo : display if new messages are available
  methods: {
    toggleChat() {
      this.chatOpen = !this.chatOpen;
      this.view = "list";
      this.activeConversation = undefined;
    },
    activateConversation(conversation) {
      this.activeConversation = this.$store.getters.getConversation(
        conversation.id
      );
      this.view = "conversation";
    },
    activateSearch() {
      this.view = "contact-search";
    },
    back() {
      switch (this.view) {
        case "conversation":
          this.view = "list";
          break;
        default:
          break;
      }
    },
    selectContact(contact) {
      let searchConversationsForContact = (contact) => {
        let conversations = this.$store.getters.conversations;
        let matchedConversation = conversations.find((conversation) => {
          let matchedContact = conversation.participantKeys
            .filter((x) => {
              return x;
            })
            .find((pk) => {
              return pk.userId === contact.userId;
            });
          return matchedContact;
        });
        if (matchedConversation) {
          this.activateConversation(matchedConversation);
        } else {
          this.createNewConversation(contact);
        }
      };
      searchConversationsForContact(contact);
    },
    async createNewConversation(contact) {
      let currentUserKey = {
        userId: this.$store.state.user.userId,
        tenantId: this.$store.state.user.tenantId,
      };
      let contactKey = {
        userId: contact.userId,
        tenantId: contact.tenantId,
      };
      let activeConversation = {
        id: Date.now().toString(),
        sortKey: this.$store.state.user.userId,
        participantKeys: [currentUserKey, contactKey],
        messages: {},
      };
      this.activeConversation = activeConversation;
      await this.$store.dispatch("createNewConversation", activeConversation);
      this.currentView = "conversation";
      await this.$store.dispatch(
        "getConversationContacts",
        this.activeConversation
      );
    },

    async sendMessage(body) {
      let message = {
        read: false,
        timeSent: Date.now(),
        timeRead: undefined,
        id: Date.now(),
        body: body,
        reaction: [],
        senderKey: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
      };
      await this.$store.dispatch("sendMessage", {
        body: message,
        conversationKey: {
          id: this.activeConversation.id,
          sortKey: this.activeConversation.sortKey,
        },
      });
    },
  },
  components: {
    NavigationIcon,
    List,
    Conversation,
    ContactSearch,
  },
  props: ["display", "contacts", "contact"],
};
</script>

<style scoped>
#spin-chat-icon {
  position: fixed;
  right: 30px;
  bottom: 30px;
  cursor: pointer;
}
#spin-chat-icon:hover {
  filter: drop-shadow(0px 0px 3px var(--shadow));
}

#chat-container {
  z-index: 2;
  height: 400px;
  width: 300px;
  background-color: var(--backgroundColor);
  position: fixed;
  right: 90px;
  bottom: 0;
  border-radius: 12px 12px 0px 0px;

  border: 1px solid var(--secondaryColor);
  filter: drop-shadow(0px -2px 2px var(--shadow));
}

@media print {
  #chat-container {
    display: none;
  }

  #spin-chat-icon {
    display: none;
  }
}
</style>
